import React, { PropTypes } from 'react';
import { Chip } from 'material-ui';
import ContactList from '../../../tc-ui/contactList';
import { JiraFlatButton } from '../../../tc-ui/small-buttons';
import OpenInNew from 'material-ui/svg-icons/action/open-in-new';
import { connect } from 'react-redux';
import R from 'ramda';

const PartnerNode = ({
  style,
  partners = [],
  contacts = [],
  payloadForResend,
  openResendContractDialog,
  isReceiver, // Partner being displayed is receiver
  forLeftNav,
  forWS,
}) => {
  const resendContract = () => openResendContractDialog(
    payloadForResend
  );
  // for contracting workspace(previously contract request, aka rate container) left nav
  // only show the associated partner
  return (
    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '16px', ...style }}>
      {
        (() => {
          if (forWS || forLeftNav) return '';
          if (isReceiver) {
            return (
              <div>
                Sent to Contacts
                <ContactList
                  users={contacts}
                  listItemStyle={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: 'block',
                  }}
                />
              </div>
            );
          }
        })()
      }
      {(() => {
        if (forWS || forLeftNav) return <b>Associated Partner</b>;
        if (isReceiver) return 'Sent to Partner';
      })()}
      {partners.map(partner => (
        <div key={partner.id}>
          <div className="flex-tc-sb">
            <a
              href={`${process.env.NEW_SYSTEM_URL}/partner-management/partner-details/${
                partner.id
              }?jwt=${localStorage.getItem('jwt')}`}
              style={{
                fontSize: '14px',
                whiteSpace: 'prewrap',
                fontWeight: 'bold',
                width: 'calc(100%-25px)',
                lineHeight: '24px',
              }}
              target="_blank"
            >
              {partner.name}
            </a>
            <OpenInNew
              style={{ color: 'rgba(0, 0, 0, 0.54)', height: '22px', width: '22px', cursor: 'pointer' }}
              onClick={() => window.open(`${process.env.NEW_SYSTEM_URL}/partner-management/partner-details/${
                partner.id
              }?jwt=${localStorage.getItem('jwt')}`)}
            />
          </div>
          {partner.tags && partner.tags.length > 0 && (
            <div style={{ display: 'flex', flexFlow: 'wrap', columnGap: '4px', rowGap: '4px' }}>
              {partner.tags.map((tag, i) => (
                <Chip key={i} labelStyle={{ fontSize: '12px' }}>
                  {tag.name}
                </Chip>
              ))}
            </div>
          )}
        </div>
      ))}
      {
        (() => {
          if (forLeftNav) return '';
          return (
            <div>
            {
              isReceiver && (
                <JiraFlatButton
                  style={{ width: '90%', margin: '8px auto 0' }}
                  labelStyle={{ padding: '0 4px' }}
                  label={forWS ? 'Send Request' : 'Resend Contract'}
                  onClick={resendContract}
                />
              )
            }
            </div>
          );
        })()
      }
    </div>
  );
};

PartnerNode.propTypes = {
  partners: PropTypes.array,
  contacts: PropTypes.array,
  payloadForResend: PropTypes.object,
  openResendContractDialog: PropTypes.func,
  forLeftNav: PropTypes.bool,
};

const mapState = ({ contracting: {
    contractActivitiesProducts,
  } }) => {
  const leftNav = contractActivitiesProducts.get('leftNav').toJS();
  const rightSideContent = contractActivitiesProducts.get('rightSideContent').toJS();
  return {
    partners: leftNav.partners,
    contacts: leftNav.contacts,
    payloadForResend: {
      contractId: leftNav.contractId,
      // this function is only available for the sender
      // for whom partners length should only be one
      partner: R.pathOr({}, ['partners', 0], leftNav),
      to: leftNav.to,
      toEmails: leftNav.toEmails,
      resendToEmails: leftNav.toEmails,
      deadlineDate: rightSideContent.deadlineDate,
    },
  };
};


export default connect(mapState, {
  openResendContractDialog: payload => ({ type: 'CHANGE_RESEND_CONTRACT_DIALOG_STATE', payload }),
})(PartnerNode);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/partner-node.jsx